import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import {
  DashboardClientPurchasedPackageDetailDto,
  UninvoicedPackageDto,
} from "./type";

export const getClientPurchasedPackageDetail = createAction(
  "GET_ACCOUNT_PURCHASED_PACKAGE_DETAIL",
  ({
    payload,
    id,
  }: SagaActionParams<DashboardClientPurchasedPackageDetailDto>) => ({
    payload,
    url: "/api/admin/clientpurchasedpackage/detail/" + id,
  })
);
export const getUnivoicedPackage = createAction(
  "GET_UNINVOICED_PACKAGE",
  ({ payload }: SagaActionParams<any>) => ({
    payload,
    url: "/api/admin/admindashboard/uninvoicedpackages",
  })
);
export const getUnapprovedPackage = createAction(
  "GET_UNAPPROVED_PACKAGE",
  ({ payload }: SagaActionParams<any>) => ({
    payload,
    url: "/api/admin/clientpurchasedpackage/approvedbanktransferlist",
  })
);
export const approvedPackage = createAction(
  "APPROVED_PACKAGE",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/clientpurchasedpackage/approvedbanktransfer",
  })
);
export const getDashboardTickets = createAction(
  "GET_DASHBOARD_TICKETS",
  ({ payload }: SagaActionParams<any>) => ({
    payload,
    url: "/api/admin/admindashboard/tickets",
  })
);

export const putInvoicedPackage = createAction(
  "INVOICED_PACKAGE",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    url: "/api/admin/admindashboard/invoicepackage/" + id,
  })
);

const dashboardSaga = [
  takeLatest<any>(
    getDashboardTickets.toString(),
    (payload: SagaGenericParams<UninvoicedPackageDto[]>) =>
      getSaga<UninvoicedPackageDto[]>(payload)
  ),
  takeLatest<any>(
    getUnapprovedPackage.toString(),
    (payload: SagaGenericParams<UninvoicedPackageDto[]>) =>
      getSaga<UninvoicedPackageDto[]>(payload)
  ),
  takeLatest<any>(
    approvedPackage.toString(),
    (payload: SagaGenericParams<any>) => postSaga<any>(payload)
  ),
  takeLatest<any>(
    getUnivoicedPackage.toString(),
    (payload: SagaGenericParams<UninvoicedPackageDto[]>) =>
      getSaga<UninvoicedPackageDto[]>(payload)
  ),
  takeLatest<any>(
    putInvoicedPackage.toString(),
    (payload: SagaGenericParams<any>) => postSaga<any>(payload)
  ),
  takeLatest<any>(
    getClientPurchasedPackageDetail.toString(),
    (payload: SagaGenericParams<DashboardClientPurchasedPackageDetailDto>) =>
      getSaga<DashboardClientPurchasedPackageDetailDto>(payload)
  ),
];

export default dashboardSaga;
